import React from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { stringify } from 'query-string'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import { RootState } from 'cityads-v3/types/reducer';

import AuthIFrame from './AuthIFrame';

import { authRegexp } from 'cityads-v3/utils/authUtils';
import config from 'cityads-v3/config';

type LoginIframeProps = {
  title: string,
  src: string,
  onEvent?: () => void,
  onResize?: () => void,
  onLoad?: () => void,
  onFail?: () => void,
  onMessage?: () => void,
  onMount?: () => void,
}

export default function LoginIframe(props: LoginIframeProps): JSX.Element {
  const { t } = useTranslation(['main']);
  const themeChanger = useThemeChanger();

  const language = useSelector((state: RootState) => state.language.language);

  const location = useLocation();
  const matchMain = useRouteMatch('/main');
  const matchManager = useRouteMatch('/main/manager');

  const isRedirectDefault = matchMain && !matchManager;

  const origin = window?.location.origin || '';
  const redirectUri = isRedirectDefault ? '' : (origin + location.pathname.replace(authRegexp, '') + location.search);

  const iframeSrc = `${config.AUTH_URL}/login?`
    + stringify({
      theme: 'material',
      lang: language,
      redirect_uri: redirectUri,
      dark_mode: themeChanger.theme.palette.type === 'dark' ? true : undefined
    })

  return (
    <AuthIFrame
      title={t('enter')}
      src={iframeSrc}
      {...props}
    />
  );
}
